<template>
    <v-card class="ma-2" :height="hCard" :loading="loading" color="light-blue" dark>
        <v-card-title>
            <v-icon x-large left>
                mdi-chart-timeline-variant
            </v-icon>
            <span class="text-subtitle-1 font-weight-medium">
                Distribuzione Cassa - {{nomeProf}}
                <v-chip small class="ml-2" color="white" light>
                    Totale: {{ importoEuro(totaleAnno) }}
                </v-chip>
            </span>
        </v-card-title>
        <v-card-text>
            <GChart v-if="datiClienti && datiClienti.length>1" type="ColumnChart" 
                    :data="chartClienti"
                    :options="chartOptionsClienti"                    
                    :settings="{language: 'it'}" />
        </v-card-text>
        <template slot="progress">
            <v-progress-linear color="white" indeterminate></v-progress-linear>
        </template>
    </v-card>
</template>

<script>import { callService, LocalDateTime, gLocalData, euro } from '@/modules/utilities.js'

    import { GChart } from 'vue-google-charts/legacy'

    export default {
        props: ['idProf'],
        components: { GChart },
        data: () => ({
            loading: false,
            hCard: 500,
            datiClienti: null,
            totaleAnno: 0,
            chartOptionsClienti: {
                height: 400,
                chartArea: { width: '75%', height: '75%' },
                legend: { position: 'right' },
                backgroundColor: { fill: 'transparent' },
                isStacked: true,
                // Configurazione per i totali in alto
                annotations: {
                    alwaysOutside: true, // Forza il testo fuori dalla colonna
                    textStyle: {
                        fontSize: 12,
                        bold: true,
                        color: '#FFF' // Colore del testo del totale
                    }
                },
                vAxis: {
                    format: 'currency'
                }
            },
            nomeProf: ''
        }),
        methods: {
            localDateTime(v) {
                return gLocalDateTime(v);
            },
            localData(v) {
                return gLocalData(v);
            },
            importoEuro(v) {
                return euro(v);
            },
            async load() {
                this.loading = true;
                let param = [this.idProf, this.$store.state.idAnnoContabile];

                let operProf = this.$store.state.listaOperatoriProfessionisti.find(o => o.professionista.id == this.idProf)
                this.nomeProf = operProf.denominazioneNormalizzata;

                const rawData = await callService("api/dashboard/dashboardCassa", param);

                // Aggiungiamo una colonna "fittizia" con il ruolo 'annotation'
                let matriceDati = [
                    ["Mese", "Contanti", "Rabbocchi", "Assegni", "POS", "Bonifici", { role: 'annotation' }]
                ];

                let accumulatoreAnnuale = 0; // Variabile temporanea per la somma totale

                if (rawData && rawData.length > 0) {
                    rawData.forEach(record => {
                        // Convertiamo i valori in numeri per sicurezza
                        let c = Number(record.contanti || 0);
                        let r = Number(record.rabbocchi || 0);
                        let a = Number(record.assegni || 0);
                        let p = Number(record.pos || 0);
                        let b = Number(record.bonifici || 0);

                        // Calcoliamo il totale della colonna
                        let totale = c + r + a + p + b;
                        accumulatoreAnnuale += totale; // Sommiamo il mese al totale anno

                        matriceDati.push([
                            String(record.mese),
                            c, r, a, p, b,
                            // Usiamo la tua funzione euro(v) per formattare il totale in alto
                            this.importoEuro(totale)
                        ]);
                    });
                }

                this.datiClienti = matriceDati;
                this.totaleAnno = accumulatoreAnnuale; // Salviamo il totale finale

                this.loading = false;
            }
        },
        computed: {
            chartClienti() {
                if (this.datiClienti == null) return null;
                return this.datiClienti;
            }
        },
        watch: {
            idProf: function (val) {
                this.load();
            }
        },
        async created() {
            await this.load();
        }
    }</script>

